import PropTypes from "prop-types";
import classnames from "classnames";

import "./formInput.scss";

const FormInput = ({ type, className, children }) => {
  return (
    <div
      className={classnames("form-input", className, {
        [`form-input--${type}`]: type,
      })}
    >
      {children}
    </div>
  );
};

FormInput.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FormInput;
